<template lang="pug">
.user-picture(@click='$emit(`click`)')
  img.rounded-circle.img-72(
    v-if="imgSrc && imgSrc !== ''"
    :src="imgSrc"
    style='object-fit: cover;'
  )
  .rounded-circle.img-72(v-else style="background-color: #eee;")
  .user-numbadge.rounded-circle.d-flex.justify-content-center.align-items-center
    | {{ badgeNumber }}

</template>

<script>
export default {
  props: {
    imgSrc: {
      // default: 'http://placekitten.com/72/72',
      default: '',
    },
    badgeNumber: {
      default: 0,
    },
    // grade: {
    //   default: 'a',
    // },
  },
  data: () => ({
    // COLORS: {
    //   a: 'green',
    // },
  }),
};
</script>

<style lang="scss">
.user-picture {
  height: fit-content;
  position: relative;

  cursor: pointer;

  .user-numbadge {
    width: 32px;
    height: 32px;
    color: var(--white);
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #FC2929;
    // border: 1px solid var(--success);
    // box-shadow: inset 0 0 0 1px var(--white);
  }

  transition: 0.2s;

  &:hover {
    filter: brightness(0.75);

    // transform: scale(1.05);
    // opacity: 0.85;
  }
  &:active {
    filter: brightness(0.5);
    transform: scale(0.9);
  }
}
</style>
